import CONSTANTS from '../constants'
import { postRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'
import { addEventLog } from '../../pages/warningCitation/redux/actions/EventsLog'

//Update waiting list
export const updateWaitingList = (data) => (dispatch) => {
	dispatch(addEventLog(data, CONSTANTS.UPDATE_WAITING_LIST_REQUEST))
	dispatch({ type: CONSTANTS.UPDATE_WAITING_LIST_REQUEST })
	return postRequest(APICONFIG.getWaitingListUrl, data).then((res) => {
		let resObject = { ...data, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.UPDATE_WAITING_LIST_SUCCESS))
		dispatch({ type: CONSTANTS.UPDATE_WAITING_LIST_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let errObject = { ...data, ...err }
		dispatch(addEventLog(errObject, CONSTANTS.UPDATE_WAITING_LIST_FAILURE))
		dispatch({ type: CONSTANTS.UPDATE_WAITING_LIST_FAILURE, errorMessage: '' })
		return err
	})
}